<template>
  <div style="height: 100%">
    <div style="margin: 0 20px;height: 30px;">
      <div style="color: #00d5ff;width: 375px" class="nav-top-left">
<!--        <div style="float: left;margin-top: 3px;line-height: 28px" v-if="moduletag !== 2">-->
<!--          <img v-if="weatherObj.temperature !== ''" style="width: 20px;height: 20px;" :src="getWeatherImg(weatherObj.weather)">&nbsp;-->
<!--        </div>-->
<!--        <div style="float: left;width: 325px" v-if="moduletag !== 2">-->
<!--          <span v-if="weatherObj.temperature !== ''">{{weatherObj.temperature}}℃</span>&nbsp;-->
<!--          <span v-if="weatherObj.temperature !== ''">{{weatherObj.weather}}</span>&nbsp;&nbsp;-->
<!--          <span v-if="moduletag !== 2" style="vertical-align: middle;" class="font-span">{{nowTime}}</span>-->
<!--        </div>-->
        <!--   jssip拨打电话   -->
        <div v-if="sipinfo.sip_type === '2'" style="float: left;margin-top: 5px">
          <img style="width: 20px;height: 20px;cursor: pointer" src="../../../assets/sipicon/index_phone_click.png" @click="openJssip()">
        </div>
        <div style="clear: both"></div>
      </div>
      <!--   jssip拨打电话   -->
      <div class="jssip-open" v-show="openShow">
        <sip-keyboard ref="sip"></sip-keyboard>
      </div>
      <!--   退出登录   -->
      <div class="nav-top-right" style="display:table;">
        <div v-if="moduletag === 2" style="height: 10px"></div>
        <div v-else style="height: 15px"></div>
        <i class="el-icon-switch-button" style="font-size: 20px;vertical-align: middle;color: red;cursor: pointer" @click="loginOut()"></i>
      </div>
      <!--   系统人名   -->
      <div class="nav-top-right1" style="display:table;text-align: center;padding-right: 10px">
        <div style="height: 15px"></div>
        <span v-if="moduletag !== 2" style="color: #00d5ff;font-size: 12px">{{orgname}}</span><br v-if="moduletag !== 2">
        <span style="color: #00d5ff;font-size: 14px">{{personname}}</span>
      </div>
      <!--   管理账号下是否能关闭报警通知   -->
      <div v-if="(role === 'superadmin' || role === 'admin') && moduletag !== 2" class="nav-top-right" style="display:table;">
        <div style="height: 15px"></div>
        <el-switch title="是否关闭报警通知" v-model="switchAlarm" active-color="#17E5E5" inactive-color="#cccccc" @change="changeSwitchAlarm"></el-switch>&nbsp;
      </div>
      <!--   客服上下坐席   -->
      <div class="nav-top-right" style="display:table;">
        <div style="height: 15px"></div>
        <el-switch title="客服坐席" v-if="role === 'csd' && moduletag !== 2" v-model="switchValue" active-color="#17E5E5" inactive-color="#cccccc" @change="changeSwitch"></el-switch>&nbsp;
      </div>
      <!--   居家快捷操作   -->
      <div v-if="moduletag !== 2" class="nav-top-right" style="display:table;">
        <div style="height: 15px"></div>
        <el-popover v-fixZoom v-if="role === 'superadmin' || role === 'admin' || role === 'op'" placement="top-start" width="80" trigger="hover" class="popper my-popper">
          <div style="text-align: center;">
            <div class="item-fast" @click="addServiceObj()" v-if="role === 'superadmin' || role === 'admin' || role === 'op'">添加人员</div>
<!--            <div class="item-fast" @click="openService()">发起服务</div>-->
          </div>
          <i slot="reference" style="color: yellow;font-size: 14px;" class="el-icon-star-on">快捷操作&nbsp;</i>
        </el-popover>
      </div>
    </div>
    <!--   通话提示   -->
    <div v-if="showCalling" class="show-telephone">
      <div v-if="callUp">
        <div style="height: 30px"></div>
        <div style="height: 45px;">
          <div style="width: 60px;height: 45px;float: left;text-align: right"><img src="../../../assets/sipicon/index_window_phone.png"></div>
          <div style="width: 240px;height: 45px;line-height:25px;float: left;text-align: left;font-size: 18px;">&nbsp;{{telephone}}</div>
        </div>
        <div style="height: 45px">
          <div style="width: 145px;float: left">
            <div class="refuse-call" @click="endCalling()">拒绝</div>
          </div>
          <div style="width: 145px;float: left">
            <div class="accept-call" @click="acceptCalling()">接听</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="height: 20px"></div>
        <div style="height: 25px">{{telephone}}</div>
        <div style="height: 30px;color: #999999">
          <span v-if="startTime === ''">正在呼叫中</span>
          <span v-else>{{startTime}}</span>
        </div>
        <div class="hang-up" @click="endCalling()">呼叫结束</div>
      </div>
    </div>
    <!--快捷编辑服务对象-->
    <el-dialog :visible.sync="quickShow" v-if="quickShow" :close-on-click-modal="false" width="1180px" center class="all-open">
      <quick-open :quickObj="quickObj" v-model="quickShow"></quick-open>
    </el-dialog>
  </div>
</template>

<script>
import {closeSub, unsubjcribe, subscribeSub} from '../../../mq'
import {startSIP} from '../../../sip/sip_index'
import {siponline, sipoffline} from '../../../api/csdsip'
import sipKeyboard from './sipKeyboard'
import quickOpen from '../../datamanagement/quick/quickOpen'
export default {
  name: 'navTop',
  components: {sipKeyboard, quickOpen},
  data () {
    return {
      evenNumber: true,
      weatherObj: {
        weather: '',
        temperature: ''
      },
      timer: null,
      nowTime: '',
      switchValue: false,
      orgname: '',
      personname: '',
      role: '',
      sipinfo: '',
      openShow: false,
      showCalling: false,
      keyboardCall: true,
      num: '',
      telephone: '',
      startTime: '',
      intervalTime: null,
      isCare: true,
      callUp: true,
      isCalling: '', // 判断callUp  0来电显示 1拨打显示
      quickShow: false,
      quickObj: {
        quickTitle: '服务对象快捷操作',
        isQuick: true,
        isAdd: true,
        oldPersonRow: '',
        orgcommunitys: [],
        orghomes: [],
        frequencys: [],
        projects: []
      },
      moduletag: '',
      switchAlarm: true
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.evenNumber = this.$store.getters.get_evenNumber
    this.weatherObj = this.$store.getters.get_weather
    this.golobleObject.sendWeather = this.getWeather
    this.golobleObject.getCsdSip = this.getOnline
    this.golobleObject.sendCalling = this.getShowCalling
    this.golobleObject.sendCallTime = this.getTimeing
    this.golobleObject.sendKeyboard = this.getKeyboard
    this.orgname = this.$store.state.user.orgname
    this.personname = this.$store.state.user.personname
    this.role = this.$store.state.user.role
    this.sipinfo = this.$store.state.user.sipinfo
    this.switchValue = this.$store.getters.get_isSip
  },
  mounted () {
    this.timer = setInterval(() => {
      this.timeFormate()
    }, 1000)
    console.log(this.sipinfo)
    if (this.sipinfo.sip_svrip && this.sipinfo.sip_svrip !== '') {
      this.getsip()
    }
  },
  methods: {
    getTimeing () {
      if (this.isCare) {
        let count = 0
        this.intervalTime = setInterval(() => {
          count++
          this.timeStarting(count)
        }, 1000)
      }
    },
    timeStarting (count) {
      let s = parseInt(count % 60)
      let m = parseInt((count / 60) % 60)
      let h = parseInt(count / 60 / 60)
      if (s < 10) {
        s = '0' + s
      }
      if (m < 10) {
        m = '0' + m
      }
      if (h < 10) {
        h = '0' + h
      }
      this.startTime = h + ':' + m + ':' + s
      // console.log(this.startTime)
    },
    // phone 号码 客服关爱拨打电话val === 1  结束通话val === 0 来电显示num === 0 客服关爱拨打电话 num === 0
    getShowCalling (phone, val, num) {
      // console.log(11111, phone, val, num)
      this.telephone = phone
      if (val === 0) {
        if (this.intervalTime !== null) {
          clearInterval(this.intervalTime)
        }
        this.showCalling = false
        this.isCare = false
      } else {
        this.showCalling = true
        this.isCare = true
      }
      if (num === 0) {
        this.callUp = true // 来电显示
      } else {
        this.callUp = false // 去电显示
      }
    },
    // 结束通话
    endCalling () {
      // console.log(12345)
      this.golobleObject.sendEndPhone()
      clearInterval(this.intervalTime)
      this.intervalTime = null
      this.telephone = ''
      this.showCalling = false
      this.isCare = false
      this.keyboardCall = true
      this.callUp = true
      this.startTime = ''
    },
    // 对方结束通话
    getKeyboard () {
      clearInterval(this.intervalTime)
      this.intervalTime = null
      this.telephone = ''
      this.showCalling = false
      this.isCare = false
      this.keyboardCall = true
      this.callUp = true
      this.startTime = ''
    },
    // 接听电话
    acceptCalling () {
      this.callUp = false
      this.golobleObject.sendAcceptCall()
      this.isCare = true
      this.getTimeing()
    },
    // jssip电话
    openJssip () {
      this.openShow = !this.openShow
    },
    getWeather () {
      this.weatherObj = this.$store.getters.get_weather
    },
    timeFormate () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      this.nowTime = date
    },
    getWeatherImg (type) {
      return this.commonType.weatherIcon(type)
    },
    getsip () {
      console.log(988, 'sip', this.sipinfo)
      startSIP()
    },
    // 获取客服在线
    getOnline () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      let sipinfo = this.$store.state.user.sipinfo
      this.sipinfo = sipinfo
      console.log(this.sipinfo)
      if (sipinfo.sip_type === 2) {
        this.$refs.sip.init() // 2 IP WebRTC 电话
      } else if (sipinfo.sip_type === 1) {
        this.getsip() // 1 SIP软电话
      }
      let data = {
        id: 0,
        sipid: sipinfo.id,
        syspersonid: sipinfo.syspersonid,
        onlinetime: date
      }
      siponline(data).then(res => {
        this.switchValue = true
        this.$store.commit('set_csdsip', res.data.sip_onlineid)
        this.$store.commit('set_isSip', this.switchValue)
        this.$notify({ title: '成功', message: '坐席成功', type: 'success', duration: 2000 })
      }).catch(() => {})
    },
    changeSwitch () {
      let sipinfo = this.$store.state.user.sipinfo
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      if (this.switchValue) {
        let data = {
          id: 0,
          sipid: sipinfo.id,
          syspersonid: sipinfo.syspersonid,
          onlinetime: date
        }
        siponline(data).then(res => {
          this.switchValue = true
          this.$store.commit('set_isSip', this.switchValue)
          this.$notify({ title: '成功', message: '坐席成功', type: 'success', duration: 2000 })
        }).catch(() => {
          this.switchValue = false
          this.$store.commit('set_isSip', this.switchValue)
        })
      } else {
        let id = this.$store.getters.get_csdsip
        let data = {
          id: id,
          sipid: sipinfo.id,
          syspersonid: sipinfo.syspersonid,
          offlinetime: date
        }
        sipoffline(data).then(res => {
          let mqttlevel = this.$store.state.user.sipinfo.mqttlevel
          unsubjcribe(mqttlevel)
          this.switchValue = false
          this.$store.commit('set_isSip', this.switchValue)
          this.$notify({ title: '成功', message: '坐席下线', type: 'success', duration: 2000 })
        }).catch(() => {
          this.switchValue = true
          this.$store.commit('set_isSip', this.switchValue)
        })
      }
    },
    changeSwitchAlarm () {
      console.log(this.switchAlarm)
      let mqtts = this.$store.state.user.mqtts
      for (let i = 0; i < mqtts.length; i++) {
        if (this.switchAlarm) {
          subscribeSub(mqtts[i])
          const alllevel = mqtts[i] + '/#'
          subscribeSub(alllevel)
        } else {
          unsubjcribe(mqtts[i])
          const alllevel = mqtts[i] + '/#'
          unsubjcribe(alllevel)
        }
      }
      this.$notify({ title: '成功', message: '发生成功', type: 'success', duration: 2000 })
    },
    // 快捷操作服务对象
    addServiceObj () {
      this.quickTitle = '快捷操作服务对象'
      this.quickShow = true
    },
    // 发起服务
    openService () {},
    loginOut () {
      // removeToken()
      // this.$router.push({path: '/'})
      this.$store.dispatch('LogOut').then(() => {
        this.$store.commit('tabs', [])
        closeSub()
        this.$store.commit('set_path', true)
        this.store2.dispatch('other/update_loginout_info', [])
        this.$router.push({path: '/'})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.item-fast{
  height: 30px;
  line-height: 30px;
  color: #cccccc;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.item-fast:hover{
  color: #00b5d9;
  /*background-color: rgba(0, 132, 255, 0.6);*/
}
.nav-top-left{
  float: left;
  height: 30px;;
  line-height: 29px;
  font-size: 18px;
}
.nav-top-right{
  float: right;
  height: 30px;;
  line-height: 29px;
  color: #17e6e6;
  font-size: 18px;
}
.nav-top-right1{
  float: right;
  height: 30px;;
  color: #17e6e6;
}
  .font-span{
    font-size: 24px;
    font-family: letisgoDigital!important;
  }
  .jssip-open{
    position: absolute;
    z-index: 999999;
    top: 35px;
    left: 270px;
  }
  .show-telephone{
    position: absolute;
    width: 300px;
    height: 120px;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 10px;
    z-index: 999999;
    top: 35px;
    left: 100px;
    text-align: center;
  }
.hang-up{
  cursor: pointer;
  width: 140px;
  height: 26px;
  line-height: 26px;
  color: white;
  text-align: center;
  margin: auto;
  background-color: red;
  border-radius: 13px;
}
  .refuse-call{
    cursor: pointer;
    width: 100px;
    height: 26px;
    line-height: 26px;
    color: white;
    text-align: center;
    margin: auto;
    background-image: linear-gradient(0deg,
    #ff0000 0%,
    #bf0000 100%);
    border-radius: 13px;
  }
.accept-call{
  cursor: pointer;
  width: 100px;
  height: 26px;
  line-height: 26px;
  color: white;
  text-align: center;
  margin: auto;
  background-image: linear-gradient(0deg,
  #00bf20 0%,
  #00ff2b 100%);
  border-radius: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/navTop.vue